import mixpanel from 'mixpanel-browser';
import logger from '@greenlightme/logger';
import getConfig from 'next/config';
import { trackWithFingerprint } from './trackWithFingerprint';

const { publicRuntimeConfig } = getConfig();
const { mixPanelPid } = publicRuntimeConfig;

// const enabledEnv = ['development', 'staging', 'production'].includes(nodeEnv);

export const initializeMixpanel = () => {
  //   if (enabledEnv) {
  logger.info('Initializing Mixpanel.');
  if (mixPanelPid && mixPanelPid !== '') {
    mixpanel.init(mixPanelPid, {
      record_sessions_percent: 100,
      persistence: 'localStorage',
      record_block_selector: '.mp-block-mask',
      record_mask_text_selector: '.mp-mask'
    });

    mixpanel.start_session_recording();
    logger.info('Starting Mixpanel session replay.');
  } else {
    logger.info('Unable to start Mixpanel');
    if (typeof window !== 'undefined') {
      console.warn(
        '⚠️ NEXT_PUBLIC_MIXPANEL_PROJECT_ID is not set. Mixpanel will not work.'
      );
    }
  }
  //   }
};

/**
 * Register experiment as super property to ensure it's included with all events
 * @param experimentKey - The experiment key
 * @param variationKey - The variation key
 */
export const registerExperimentSuperProperty = (
  experimentKey: string,
  variationKey: string
) => {
  if (
    typeof window !== 'undefined' &&
    window.mixpanel &&
    typeof window.mixpanel.register === 'function'
  ) {
    try {
      window.mixpanel.register({
        [`experiment_${experimentKey}`]: variationKey,
        [`experiment_${experimentKey}_key`]: experimentKey
      });
      logger.info(
        `Registered experiment super property: ${experimentKey} = ${variationKey}`
      );
    } catch (error) {
      logger.error(`Failed to register experiment super property: ${error}`);
    }
  }
};

/**
 * Get experiment properties from session storage for inclusion in events
 * @returns Object with experiment properties
 */
export const getExperimentProperties = () => {
  const experimentProperties: Record<string, any> = {};

  if (typeof window !== 'undefined' && window.sessionStorage) {
    const experimentKeys = Object.keys(sessionStorage).filter((key) =>
      key.startsWith('gl_')
    );
    experimentKeys.forEach((key) => {
      const experimentKey = key.replace('gl_', '');
      const variationKey = sessionStorage.getItem(key);
      if (variationKey) {
        experimentProperties[`experiment_${experimentKey}`] = variationKey;
        experimentProperties[`experiment_${experimentKey}_key`] = experimentKey;
      }
    });
  }

  return experimentProperties;
};

/**
 * Track event with experiment properties automatically included
 * @param eventName - The event name
 * @param properties - Event properties
 */
export const trackWithExperimentProperties = (
  eventName: string,
  properties: Record<string, any> = {}
) => {
  const experimentProperties = getExperimentProperties();
  const eventWithExperiments = {
    ...properties,
    ...experimentProperties
  };

  // Use the existing trackWithFingerprint function
  return trackWithFingerprint(eventName, eventWithExperiments);
};
